/* eslint-disable @typescript-eslint/naming-convention */
export enum PermissionLevel {
  SUPER = 'super',
  ADMIN = 'admin',
  SUPPORT = 'support',
  CHALLENGE_WRITER = 'challengeWriter',
  STUDEND = 'student'
}
